import { render } from "./HollywoodSmileLongevity.vue?vue&type=template&id=779693b4"
import script from "./HollywoodSmileLongevity.vue?vue&type=script&lang=js"
export * from "./HollywoodSmileLongevity.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__